export default __webpack_public_path__ + "7d99d11e1257450eb04155e8c85c3489.png";